import React from "react";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function NacpServices({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <Table bordered responsive>
          <thead>
            <tr className="table-secondary text-center align-middle">
              <th>Indicator</th>
              <th>Achivement for the reporting month</th>
              <th>New Registration in the reporting month</th>
              <th>No of LFUs</th>
              <th>Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Total no of HRG, bridge and vulnerable population covered through TI/LWS</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total no of IDUs on OST</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total no of contacts with ‘at-risk’ population through ‘Sampoorna Suraksha’ Centers (target of SSK, and achievement against target)</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total  No of individual found STI Symptomatic in a month</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total no of STI/RTI patients managed in the month</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total no of STI/RTI patients referred from SSK/DSRC/TI/LWS/other health facilities to ICTC for HIV testing in the month</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total no of individuals screened for HIV in all facilities and camps</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Out of total individuals screened for HIV, no of individuals found reactive</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Out of above total no of persons confirmed HIV Positive</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Out of above total no of HIV positive linked to ART</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total no. of individuals screened for Syphilis</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Out of above total no of individuals found Syphilis Reactive</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Out of above total no of individuals treated for Syphilis</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total no. of PLHIV already on ART</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total no of viral load test conducted</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total no of PLHIV who are on ART and are virally suppressed</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>No of TB symptomatic cases referred for the confirmation and treatment</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td className="table-secondary">Not Applicable</td>
              <td className="table-secondary">Not Applicable</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

          </tbody>
        </Table>
      </div>


      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
